import settingsService from '../services';
import { MembersScreenResponse } from '../types/members-types';
import AvailableRolesStore from '../stores/available-roles-store';
import InviteMemberStore from '../stores/invite-user-store';
import MembersStore from '../stores/members-store';
import { snapshot } from 'valtio';
import { reduceRelatedMembersIDs } from '../utils/members-utils';

export const loadMembersScreen = async (): Promise<void> => {
  MembersStore.isLoading = true;
  const results: MembersScreenResponse =
    await settingsService.getMembersScreen.execute();

  MembersStore.activeMembers = reduceRelatedMembersIDs(results.activeMembers);

  AvailableRolesStore.availableRoles = results.availableRoles;
  InviteMemberStore.pendingInvitationMembers = results.pendingInvitationMembers;

  MembersStore.isLoading = false;
};

export const getActiveMembers = async () => {
  const membersStore = snapshot(MembersStore);
  if (membersStore.activeMembers.length > 0) {
    return membersStore.activeMembers.map(m => ({
      user_id: m.user_id,
      name: m.name,
      email: m.email,
    }));
  }
  const activeMembers = await settingsService.getActiveMembers.execute();
  if (activeMembers) {
    return reduceRelatedMembersIDs(activeMembers).map(m => ({
      user_id: m.user_id,
      name: m.name,
      email: m.email,
    }));
  }
};
